// gummies-faq.js
// Enhances <details> with smooth height animations and optional single-open-per-category.

(function () {
  const sections = document.querySelectorAll('[id^="gummies-faq-"] .gummies-faq__container');
  if (!sections.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((wrap) => {
    const singleOpen = String(wrap.dataset.singleOpen) === 'true';

    wrap.querySelectorAll('.gf-item').forEach((item) => {
      const summary = item.querySelector('.gf-question');
      const answer  = item.querySelector('.gf-answer');

      if (!summary || !answer) return;

      // Start closed height for animation
      if (!item.hasAttribute('open')) {
        answer.style.height = '0px';
      } else {
        answer.style.height = answer.scrollHeight + 'px';
      }

      summary.addEventListener('click', (e) => {
        // Prevent default instant toggle to allow animation control
        e.preventDefault();

        const willOpen = !item.hasAttribute('open');

        if (singleOpen && willOpen) {
          // Close siblings within the same category
          const group = item.dataset.group;
          wrap.querySelectorAll(`.gf-item[data-group="${group}"][open]`).forEach((openItem) => {
            if (openItem === item) return;
            collapse(openItem);
          });
        }

        willOpen ? expand(item) : collapse(item);
      });

      // When <details> changes via keyboard or programmatically, sync heights
      item.addEventListener('toggle', () => {
        if (item.open) {
          answer.style.height = answer.scrollHeight + 'px';
        }
      });

      function expand(target) {
        const body = target.querySelector('.gf-answer');
        target.setAttribute('open', '');
        if (prefersReduced) {
          body.style.height = 'auto';
          return;
        }
        const endHeight = body.scrollHeight;
        body.style.height = endHeight + 'px';
        body.style.transition = 'height 220ms ease';
        body.addEventListener('transitionend', onEnd, { once: true });
        function onEnd() {
          body.style.height = 'auto'; // allow intrinsic growth
          body.style.transition = '';
        }
      }

      function collapse(target) {
        const body = target.querySelector('.gf-answer');
        if (!target.hasAttribute('open')) return;
        if (prefersReduced) {
          target.removeAttribute('open');
          body.style.height = '0px';
          return;
        }
        // set fixed height then animate to 0
        body.style.height = body.scrollHeight + 'px';
        // Force reflow to apply the fixed height before transition
        // eslint-disable-next-line no-unused-expressions
        body.offsetHeight;
        body.style.transition = 'height 200ms ease';
        body.style.height = '0px';
        body.addEventListener('transitionend', onEnd, { once: true });
        function onEnd() {
          target.removeAttribute('open');
          body.style.transition = '';
        }
      }
    });
  });
})();
